// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e0a0e14898d3b0ba1f03","117":"8285d690ca52ede4bdcb","118":"7fe4dfb73651668ff4bd","166":"63fa3ce9519915c267e3"}[chunkId] + ".chunk.js";
};